<template>
    <div >
      <div class="section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-center noInternet"> 
                            <img src="static/images/noInternet.png" alt="" class="">
                            <h2 class="red-color">Oops!</h2>
                            <p class="theme-lineheight">
                              No Internet connection found. Check your connection or try again.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'

export default {
  name: 'PageNotFound',
  components: {
    HeaderVue,
    FooterVue
  },
  data () {
    return {}
  },
  beforeCreate () {
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/Internet.vue